import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getWhatsappTemplatesQueryKey } from "modules/campaigns/lib/templates/whatsapp/whatsappTemplatesQuery"
import { UpdateWhatsappTemplateBodySchema } from "schema"
import { z } from "zod"

export const useUpdateWhatsappTemplateMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      props,
      id,
    }: {
      id: string
      props: z.infer<typeof UpdateWhatsappTemplateBodySchema>
    }) => {
      const { data } = await axios.post(`/integrations/whatsapp/templates/${id}`, props)
      return data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getWhatsappTemplatesQueryKey() })
    },
  })
}
